export const font = `
... on Metaobject {
  id
  name: field(key: "name") {
    value
  }
  hasShadow: field(key: "has_shadow") {
    value
  }
  fontFile: field(key: "font_file") {
    reference {
      ... on GenericFile {
        id
        url
        mimeType
      }
    }
  }
  preview: field(key: "preview") {
    value
  }
  previewScale: field(key: "preview_scale") {
    value
  }
}
`;
